<template>
    <section>
      <header-com/>
      <div class="container">
        <div class="fixed-block"></div>

        <div style="width:100%;margin-bottom:20px">
          <div class="typeTab">
            <div v-for="(item,index) of typeList" :class="typeId==item.id?'typeBox typeBoxActive':'typeBox'" @click="typeId = item.id" :key="index">{{item.name}}</div>
          </div>
        </div>

        <div v-if="typeId === 1">
          <div class="mb30"><order-module-title title="基本信息"/></div>
          <div class="basic info f28">
            <div>
              <span class="grey6">分类：</span>
              <span>{{detail.category}}</span>
            </div>
            <div>
              <span class="grey6">品牌：</span>
              <span>{{detail.brand}}</span>
            </div>
            <div>
              <span class="grey6">颜色：</span>
              <span>{{detail.color}}</span>
            </div>
            <div>
              <span class="grey6">款式：</span>
              <span>{{detail.style == 1?'男款':'女款'}}</span>
            </div>
          </div>
          <div class="block"></div>
          <div style="margin-top:20px;margin-bottom:30px"><order-module-title title="鉴定结果"/></div>
          <div class="resultImg">
            <img v-if="detail.examResult" src="/images/order/resultTrue.png" />
            <img v-if="!detail.examResult" src="/images/order/resultFalse.png" />
          </div>
        </div>

        <div v-if="typeId === 2" class="tabs-container">
          <photos :model='photos'/>
        </div>
      </div>
      <!-- <img src='/images/public/uppage.png' class='pageUp' @click='page(0)' v-if='showIndex != 0'>
      <img src='/images/public/downpage.png'  class='pageDown' @click='page(1)' v-if='showIndex != idIndex.length-1'> -->
    </section>
</template>

<script>
  import orderApi from '@/axios/order'
  import photos from './photos'
  export default {
    name: 'index',
    data () {
      return {
        typeList: [
        { name: '鉴定信息', id: 1 },
        { name: '宝贝相册', id: 2 }
      ],
      typeId: 1,
        id : '',
        goodsCode : '',
        isCanRepair: false,
        detail : {
          goodsCuringServiceBoList : [{
            curingServiceName : ''
          }]
        },
        photos : [],
        idIndex : [],
        showIndex : 0,
        detail: JSON.parse(this.$route.query.item)
      }
    },
    created(){
      this.id = this.detail.id + '';
      
      this.getPhotoList();
      // this.idIndex = this.id.split(',');
      // this.setIndexAction();

    },
    components: {
      photos
    },
    computed:{
      
    },
    methods : {
      setIndexAction(){
        // this.getDiagnose(this.idIndex[this.showIndex]);
        // this.getPhotoList(this.idIndex[this.showIndex]);
      },
      page(index){
        if(index){
          this.showIndex++; 
        }else{
          this.showIndex--; 
        }

        this.setIndexAction();
      },
      getPhotoList(){
        orderApi.getPhotoList({virtualGoodsId:this.detail.id}).then((res)=>{
          this.photos = res;
        })
      },
      
      changeArr(res){
        console.log(res.goodsCuringServiceRepairPointBoList)
        let obj = {};
        let arr = [];
        let noArr = [];
        res.goodsCuringServiceRepairPointBoList.forEach(element => {
          if(element.employStatus){
            arr.push(element)
          }else{
            noArr.push(element)
          }
        });
        obj = res;
        obj.goodsCuringServiceRepairPointBoList = arr.concat(noArr);
        return obj;
      },
      getDiagnose(id){
        orderApi.getDiagnose(id).then((res)=>{
          //增加数据转换
          
          this.detail = this.changeArr(res);
          //如果是客户自己，发送请求
          let params = {
            behaviorType : 11,
            goodsCodeList : res.goodsCode
          }
          orderApi.behavior(params).then((res)=>{
            
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .basic{
    display: flex;
    flex-wrap: wrap;
    div{
      width: 50%;
      line-height: 40px;
      margin-bottom: 20px;
      &:last-child, &:nth-last-child(2){
        margin-bottom: 0
      }
    }
  }
  .info{
    padding: 0 30px 30px 30px;
  }
  .pageUp,.pageDown{
    width: 100px;
    position: fixed;
    top:50%;
    right: 20px;
  }
  .pageUp{
    margin-top:-50px; 
  }
  .pageDown{
    margin-top:50px; 
  }
  .container{
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #fff;
    padding-top:120px;
    div.fixed-block{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 116px;
      background: #fff;
    }
    .tabs{
      width: 350px;
      height: 60px;
      border-radius: 12px;
      // border: 2px solid rgba(51,51,51,1);
      display: flex;
      margin-top:48px;
      background: #fff;
      .tab{
        flex: 1;
        text-align: center;
        line-height: 60px;
        
        font-weight: 500;
        color:#999999;
        position: relative;
        .bottom_line{
          width:80px;
          background: #333333;
          height: 8px;
          bottom:-10px;
          border-radius: 4px;
          position: absolute;
          left:50%;
          margin-left: -40px;
        }
        &.tab-actived{
          // background: rgba(51,51,51,1);
          color:#333333;
        }
      }
    }
  }
  .fixed-bottom{
    width: 690px;
    height: 172px;
    position: fixed;
    bottom: 0;
    display: flex;
    left: 30px;
    background: #fff;
    justify-content: space-between;
    button{
      width:330px;
      height:92px;
      border-radius:46px;
      border:2px solid rgba(51,51,51,1);
      color:rgba(51,51,51,1);
      line-height: 92px;
    }
  }

  .typeTab{
  width: 690px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  align-content: flex-start;
  border: 1px solid #333;
  border-radius: 12px;
  overflow: hidden;
  .typeBox{
    flex-grow: 1;
    height: 100%;
    text-align: center;
    font-size: 32px;
    line-height: 58px;
    border-left: 1px solid #333;
    &:nth-child(1) {
      border: none;
    }
  }
  .typeBoxActive{
    background-color: #333;
    color: white;
  }
}
.resultImg{
  width: 698px;
  margin: 0 auto;
  img{
    width: 698px;
  }
}
</style>
